module.exports = __webpack_public_path__ + "static/media/han-taste-snacks-ad2.9d818bde.png";